import React, { FC } from 'react';

interface IconProps {}

export const ManagerIcon: FC<IconProps> = ({}) => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
        >
            <path
                d="M7.5 6.75H10.5M7.5 12H16.5M7.5 15H16.5M7.5 18H10.5M6 21.75H18C18.3978 21.75 18.7794 21.592 19.0607 21.3107C19.342 21.0294 19.5 20.6478 19.5 20.25V3.75C19.5 3.35218 19.342 2.97064 19.0607 2.68934C18.7794 2.40804 18.3978 2.25 18 2.25H6C5.60218 2.25 5.22064 2.40804 4.93934 2.68934C4.65804 2.97064 4.5 3.35218 4.5 3.75V20.25C4.5 20.6478 4.65804 21.0294 4.93934 21.3107C5.22064 21.592 5.60218 21.75 6 21.75Z"
                stroke="#00AEEF"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M16.5 7.125C16.7071 7.125 16.875 6.95711 16.875 6.75C16.875 6.54289 16.7071 6.375 16.5 6.375C16.2929 6.375 16.125 6.54289 16.125 6.75C16.125 6.95711 16.2929 7.125 16.5 7.125Z"
                fill="#00AEEF"
                stroke="#00AEEF"
            />
        </svg>
    );
};
